module.exports = __webpack_public_path__ + "static/media/f1.48593c35.png";